var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumbs event-top__breadcrumbs"},_vm._l((_vm.nodes),function(item){return _c('NuxtLink',{key:item.path,staticClass:"clear",attrs:{"to":item.path}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }